module.exports = __webpack_public_path__ + "img/google.2e68668d.png";